import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'

export const Features = styled.ul`
  padding-inline-start: 20px;
  margin: 0;
`

export const SectionHeading = styled.h2`
  color: ${colors.regular};
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  text-align: center;
  margin: 0 0 56px;

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 32px;
  }
`
